import {
  PlaceType
} from "./chunk-VXLCCQ5A.js";

// src/utils/location.ts
var SUPPORTED_PLACE_TYPE_VALUES = [
  PlaceType.neighborhood,
  PlaceType.sublocality,
  PlaceType.postal_code,
  PlaceType.locality,
  PlaceType.administrative_area_level_4,
  PlaceType.administrative_area_level_1,
  PlaceType.country,
  PlaceType.natural_feature
];
var findLocalityPlaceId = (placeIds) => {
  const localityPlaceId = placeIds.find((placeId) => placeId.includes("locality."));
  if (localityPlaceId) {
    return localityPlaceId.split(".")[1];
  }
  const orderedAdminAreas = placeIds.filter((placeIds2) => placeIds2.includes("administrative_area_level_"));
  orderedAdminAreas.sort();
  orderedAdminAreas.reverse();
  if (orderedAdminAreas.length > 0) {
    return orderedAdminAreas[0]?.split(".")[1];
  }
  const countryPlaceId = placeIds.find((placeId) => placeId.includes("country."));
  return countryPlaceId?.split(".")[1];
};
var SUPPORTED_PLACE_TYPES = new Set(SUPPORTED_PLACE_TYPE_VALUES);
var getFirstSupportedPlaceType = (types) => {
  return types.find((type) => SUPPORTED_PLACE_TYPES.has(type));
};
var getLocationBreadcrumbString = ({
  listing,
  returnAllItems = false
}) => {
  let breadcrumbArray = getLocationBreadcrumbArray({ listing }).reverse();
  if (breadcrumbArray.length === 0) {
    return "";
  }
  breadcrumbArray = returnAllItems ? breadcrumbArray : breadcrumbArray.slice(0, 2);
  return breadcrumbArray.map(({ text }) => text).join(", ");
};
var getLocationBreadcrumbText = ({
  listing,
  text,
  isSmallestAddressComponentLevel
}) => {
  if (isSmallestAddressComponentLevel && "neighborhoodOverwrite" in listing && listing.neighborhoodOverwrite) {
    return listing.neighborhoodOverwrite;
  }
  return text;
};
function getLocationBreadcrumbArray({
  listing,
  shouldIncludeUrls
}) {
  const addressComponents = listing.addressComponents ?? [];
  const componentsWithText = addressComponents.filter((comp) => Boolean(comp.text));
  return componentsWithText.reduce((result, { text, placeId, autogenUrl }, index, arr) => {
    const breadcrumbText = getLocationBreadcrumbText({
      listing,
      text,
      isSmallestAddressComponentLevel: index === arr.length - 1
    });
    result.push({
      text: breadcrumbText,
      placeId,
      ...shouldIncludeUrls && autogenUrl && { autogenUrl }
    });
    return result;
  }, []);
}
var getLastBreadcrumbString = (listing) => {
  const breadcrumbArray = getLocationBreadcrumbArray({ listing });
  return breadcrumbArray.at(-1)?.text;
};

export {
  SUPPORTED_PLACE_TYPE_VALUES,
  findLocalityPlaceId,
  SUPPORTED_PLACE_TYPES,
  getFirstSupportedPlaceType,
  getLocationBreadcrumbString,
  getLocationBreadcrumbArray,
  getLastBreadcrumbString
};
